// extracted by mini-css-extract-plugin
module.exports = {"container":"TodoHeader_container__LoN8x","bar":"TodoHeader_bar__2WSJN","details":"TodoHeader_details__2rBbP"};